import { AlignTypes } from '@monorepo-web/components-library';
import { FormatTypes, helperFormat } from '@monorepo-web/utils';
export function formatRowsFluxoAtivos(fluxo_de_ativos, dispatchPDF, selectedTypes) {
    let dadosFluxoAtivos = fluxo_de_ativos ? fluxo_de_ativos.slice(1) : null;
    if (!dispatchPDF) {
        dadosFluxoAtivos = fluxo_de_ativos
            ? fluxo_de_ativos
                .slice(1)
                .filter((row) => selectedTypes.includes(row[1]))
                .filter((row) => selectedTypes.includes(row[3]))
            : null;
    }
    const rowsFluxoAtivos = dadosFluxoAtivos
        ? dadosFluxoAtivos.map((row) => {
            let i = 0;
            const dataAux = row[i++];
            return {
                data: dataAux.split('-').reverse().join('/'),
                tipo: row[i++],
                desc: row[i++],
                op: row[i++],
                quant: helperFormat(row[i++], FormatTypes.truncate),
                valBruto: helperFormat(row[i++], FormatTypes.decimals, 2),
                valLiquido: helperFormat(row[i++], FormatTypes.decimals, 2),
            };
        })
        : null;
    return rowsFluxoAtivos;
}
export function getColumnsFluxoAtivos() {
    const columnsFluxoAtivos = [
        {
            id: 'data',
            label: 'Data',
            freeze: true,
            align: AlignTypes.left,
        },
        {
            id: 'tipo',
            label: 'Tipo',
            align: AlignTypes.left,
        },
        {
            id: 'desc',
            label: 'Descrição',
            align: AlignTypes.left,
        },
        {
            id: 'op',
            label: 'Operação',
            align: AlignTypes.left,
        },
        {
            id: 'quant',
            label: 'Quantidade',
            align: AlignTypes.right,
        },
        {
            id: 'valBruto',
            label: 'Valor Bruto',
            align: AlignTypes.right,
        },
        {
            id: 'valLiquido',
            label: 'Valor Líquido',
            align: AlignTypes.right,
        },
    ];
    return columnsFluxoAtivos;
}
